import { useCollection } from "../../hooks/useCollection";
import { format } from "date-fns";
import { it } from "date-fns/locale";

export default function ProjectManodopera({ prj }) {
  // Filtra per cantiere.codice
  const { documents: presenze, error } = useCollection("presenze", [
    ["cantiere.codice", "==", prj.codice],
  ]);
  const { documents: usersData } = useCollection("users");

  // Helper functions for hours calculation (from presenzePdf.js)
  const roundEntryTimeToNextHalfHour = (date) => {
    const rounded = new Date(date);
    const minutes = rounded.getMinutes();
    if (minutes === 0) return rounded;
    if (minutes <= 30) rounded.setMinutes(30, 0, 0);
    else rounded.setHours(rounded.getHours() + 1, 0, 0, 0);
    return rounded;
  };

  const roundExitTimeToPreviousHalfHour = (date) => {
    const rounded = new Date(date);
    const minutes = rounded.getMinutes();
    if (minutes === 0 || minutes === 30) return rounded;
    if (minutes < 30) rounded.setMinutes(0, 0, 0);
    else rounded.setMinutes(30, 0, 0);
    return rounded;
  };

  const calculateHours = (presenza) => {
    if (!presenza.oraIngresso || !presenza.oraUscita) return "0.00";

    const ingresso = presenza.oraIngresso.toDate();
    const uscita = presenza.oraUscita.toDate();

    const ingressoRounded = roundEntryTimeToNextHalfHour(ingresso);
    const uscitaRounded = roundExitTimeToPreviousHalfHour(uscita);

    const diffMs = uscitaRounded - ingressoRounded;
    let diffHours = diffMs / (1000 * 60 * 60);

    if (presenza.durataPausa && presenza.durataPausa !== "nessuno") {
      const pausa = parseFloat(presenza.durataPausa);
      if (!Number.isNaN(pausa)) diffHours -= pausa;
    }

    return Math.max(0, diffHours).toFixed(2);
  };

  // Helper per ottenere il nome completo del dipendente partendo da userId
  const getUserFullName = (userId) => {
    const user = usersData?.find((u) => u.id === userId);
    if (!user) return "Utente non trovato";
    if (user.anagrafica && user.anagrafica.nome && user.anagrafica.cognome) {
      return `${user.anagrafica.nome} ${user.anagrafica.cognome}`;
    }
    return user.displayName || user.email || "Nome non disponibile";
  };

  if (error) return <div className="error">{error}</div>;
  if (!presenze || !usersData)
    return <div className="loading">Caricamento...</div>;

  // Ordina per data decrescente (più recenti prima)
  const sortedPresenze = [...presenze].sort(
    (a, b) => b.dataRegistrazione.toDate() - a.dataRegistrazione.toDate(),
  );

  return (
    <div className="project-manodopera">
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "20px",
        }}
      >
        <thead>
          <tr
            style={{
              borderBottom: "1px solid #ddd",
              textAlign: "left",
              backgroundColor: "#f9f9f9",
            }}
          >
            <th style={{ padding: "10px" }}>Dipendente</th>
            <th style={{ padding: "10px" }}>Data</th>
            <th style={{ padding: "10px" }}>Totale Ore</th>
          </tr>
        </thead>
        <tbody>
          {sortedPresenze.map((p) => (
            <tr key={p.id} style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "10px" }}>{getUserFullName(p.userId)}</td>
              <td style={{ padding: "10px" }}>
                {format(p.dataRegistrazione.toDate(), "dd/MM/yyyy", {
                  locale: it,
                })}
              </td>
              <td style={{ padding: "10px", fontWeight: "bold" }}>
                {calculateHours(p)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {sortedPresenze.length === 0 && (
        <p style={{ padding: "20px", textAlign: "center", color: "#666" }}>
          Nessuna presenza trovata per questo progetto.
        </p>
      )}
    </div>
  );
}
